import type {
  IParseBreadcrumbProps,
  TParseBreadcrumbData,
} from 'types/breadcrumb/breadcrumb.types';

const parseBreadcrumb = (
  { name = null, breadcrumb, url }: IParseBreadcrumbProps,
  origem: string = null,
  moreOffers = false
): TParseBreadcrumbData => {
  const origemParam = origem ? `?origem=${origem}` : '';

  const breadcrumbData = [...breadcrumb];

  if (name) {
    breadcrumbData.push({ name, url });
  }

  if (moreOffers) {
    breadcrumbData.push({ name: 'Mais ofertas', url: '#' });
  }

  return breadcrumbData.reduce(
    (prevVal, item, index) => {
      const { name: itemName, url: path } = item;
      const { crumbs, crumbsSeo } = prevVal;

      const itemParsed = {
        default: {
          key: `breadcrumb-${itemName}`,
          id: `breadcrumb-${itemName}`,
          name: itemName,
          label: itemName,
          path: `${path}${origemParam}`,
          href: `${path}${origemParam}`,
        },
        seo: {
          position: index + 1,
          name: itemName,
          item: `${path}${origemParam}`,
        },
      };

      return {
        crumbs: [...crumbs, itemParsed.default],
        crumbsSeo: [...crumbsSeo, itemParsed.seo],
      };
    },
    { crumbs: [], crumbsSeo: [] }
  );
};

export default parseBreadcrumb;
